import React from 'react';
import "./style.css";
import SeoHead from '../../Components/SeoHead/SeoHead';

function Estimate() {
    return (
        <>
            <SeoHead
                title="Presupuesto"
                path="/presupuesto"
                description="Solicitá un presupuesto sin cargo para mármoles, granitos y cuarzos. Marmolería Colaiacovo, Flores, Buenos Aires."
            />
            <div className="container mx-auto px-4 py-12 max-w-2xl text-center">
                <h1 className="text-3xl font-bold mb-6 section-title">PRESUPUESTO</h1>
                <p className="text-gray-600 mb-8 text-lg">
                    ¿Necesitás una cotización? Contactanos directamente y te respondemos en menos de 24 hs.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
                    <div className="bg-white rounded-2xl shadow-lg p-6">
                        <h2 className="font-semibold text-lg mb-2" style={{ color: '#ff7a00' }}>📞 Por WhatsApp</h2>
                        <p className="text-gray-600 mb-3">Envianos fotos y medidas del espacio.</p>
                        <a
                            href="https://wa.me/5491151494430?text=Hola%2C+queria+consultar+un+presupuesto"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block font-bold py-2 px-5 rounded-lg text-white transition-all duration-200"
                            style={{ background: '#ff7a00' }}
                            aria-label="Solicitar presupuesto por WhatsApp"
                        >
                            Escribir por WhatsApp
                        </a>
                    </div>
                    <div className="bg-white rounded-2xl shadow-lg p-6">
                        <h2 className="font-semibold text-lg mb-2" style={{ color: '#ff7a00' }}>✉️ Por email</h2>
                        <p className="text-gray-600 mb-3">Describí el proyecto y te respondemos a la brevedad.</p>
                        <a
                            href="mailto:marmolesgranitos@gmail.com?subject=Solicitud%20de%20presupuesto"
                            className="inline-block font-bold py-2 px-5 rounded-lg text-white transition-all duration-200"
                            style={{ background: '#ff7a00' }}
                            aria-label="Solicitar presupuesto por email"
                        >
                            Enviar email
                        </a>
                    </div>
                </div>
                <p className="mt-8 text-sm text-gray-400">
                    También podés visitarnos en Balbastro 2588, Flores, Buenos Aires — lunes a viernes de 9 a 17 hs.
                </p>
            </div>
        </>
    );
}

export default Estimate;


